<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :max-width="maxWidth"
      :width="width"
      @mouseenter="isContainer ? setState('hoverContainer', note) : setState('hoverPage', note.id)"
      @mouseleave="isContainer ? setState('hoverContainer', false) : setState('hoverPage', false)"
      @mousedown.stop="testForDragStart"
      :draggable="false"
      :elevation="!hover ? (nested || isContainer ? 0 : 1) : 2"
      :outlined="isContainer && !nested"
      class="py-0"
      :class="{
        grey: selected || (hoveringPage && !draggingCard) || hoveringContainer,
        'lighten-3': selected || hoveringPage || hoverContainer,
        'no-events': (draggingCard && (draggingCard.id == note.id || nested)) || note.dragCard,
        blue: draggingCard && draggingCard.id == note.id && !inSection && hoveringTag !== false
      }"
      :style="
        `left: ${note.x}px; top: ${
          note.y
        }px; position: absolute; transition: .2 s ease all; z-index: ${
          dragging ? 2 : 1
        }; transition: 0.2s ease width, 0.2s ease max-width;`
      "
    >
      <v-row :key="note.id" class="no-gutters my-1 card-content">
        <!-- <v-col class="shrink">
          <oh-v-icon
            :scale="isContainer && !nested ? 1.5 : 1"
            class="ml-6"
            :class="icon.color"
            :name="icon.icon"
          ></oh-v-icon>
        </v-col> -->
        <v-col class="pt-2 pl-0 pr-0" @dblclick.stop.prevent="setupEditing">
          <v-layout column class="px-0 mb-1" :class="{ 'nested-title': nested }">
            <embedded-card-content
              ref="cardContent"
              :page="page"
              :pageId="page.id"
              :parentPageId="container.pageId"
              :nested="nested"
              :card="true"
              :showSectionify="!nested && !inSection"
              :userCanEdit="true"
              :renderEditable="true"
              :clickToEdit="!editing"
              @blur="editing = false"
              @deleteNote="removeNotePages({ noteId: note.id, pageId: container.pageId })"
              @handleEnter="nested ? $emit('addNoteBelow') : createNote(0)"
            ></embedded-card-content>
            <!-- <v-text-field
              v-if="editing"
              v-model="title"
              autofocus
              dense
              hide-details
              @keydown.enter="editing = false"
              @keydown.esc="editing = false"
              @blur="editing = false"
            ></v-text-field>
            <div v-else style="user-select: none;">{{ title }}</div> -->
          </v-layout>
        </v-col>
        <v-col class="shrink pa-y pr-1 grey--text" v-if="nested">
          <span v-show="hover">{{ childrenLength }}</span>
        </v-col>
      </v-row>
      <v-row class="" style="position: relative; z-index: 5;" no-gutters v-if="!nested">
        <v-hover v-slot:default="hoverBtn">
          <v-btn
            v-show="hover || childrenLength || isContainer"
            style="position: absolute; left: 50%; margin-left: -12px; bottom: -15px; z-index: 5; border: 1px solid #e0e0e0 !important;"
            small
            icon
            class="white"
            @click="isContainer = !isContainer"
          >
            <span v-show="childrenLength && !isContainer && !hoverBtn.hover">
              {{ childrenLength }}
            </span>
            <oh-v-icon
              v-show="hoverBtn.hover || isContainer || (hover && !childrenLength)"
              x-small
              name="md-keyboardarrowdown"
              style="transition: .1s ease transform;"
              :style="isContainer ? 'transform: rotate(180deg)' : ''"
            ></oh-v-icon>
          </v-btn>
        </v-hover>
      </v-row>
      <v-divider v-if="isContainer && !nested"></v-divider>
      <v-row class="px-2" no-gutters v-if="isContainer && !nested">
        <template v-for="(childNote, index) in pageNotes">
          <div style="position: relative; width: 100%; height: 6px;" :key="'sort' + childNote.id">
            <div
              @mouseover="setState('dropZoneHover', childNote.id)"
              @mouseleave="setState('dropZoneHover', false)"
              class="hover-trigger"
              style="position: absolute; height: 12px; left: 0; right: 0; z-index: 4;"
            >
              <div
                :style="
                  `position: relative; width: 100%; height: 4px; background: #7ab9f7; opacity: ${
                    !!draggingCard && dropZoneHover == childNote.id ? 1 : 0
                  }`
                "
              ></div>
            </div>
          </div>
          <item-card
            @addNoteBelow="createNote(index + 1)"
            :draggingOut="draggingCard && draggingCard.id == childNote.id"
            :hoveringPage="hoverPage == childNote.id"
            :nested="true"
            :key="childNote.id"
            ref="children"
            :note="childNote"
            :container="note"
            :style="
              `position: relative; left: auto; top: auto; ${
                draggingCard && draggingCard.id == childNote.id ? 'opacity: 0;' : ''
              }'`
            "
          >
          </item-card>
        </template>
        <v-btn block plain @click="createNote()">
          <oh-v-icon name="md-add" scale="0.7"></oh-v-icon>
          New
        </v-btn>
      </v-row>
      <!-- <v-row class="pa-2 grey lighten-2" no-gutters v-else-if="note.showNotePage && !nested">
        <note-page
          @mousedown.left.stop
          :colIndex="colIndex"
          :key="page.id"
          :pageId="page.id"
          :dashboardView="false"
          :pinned="true"
          :nestedPage="true"
          :outline="true"
          class="white mb-1 pr-2"
          :showToolbar="false"
          style=""
          @close=""
          @expand=""
          @toggleLock=""
        ></note-page>
      </v-row> -->
      <v-row no-gutters v-if="!nested && note.isContainer">
        <v-btn text class="ml-3">
          <oh-v-icon v-show="hover" name="md-addbox-outlined" class="grey--text"></oh-v-icon>
        </v-btn>
      </v-row>
    </v-card>
  </v-hover>
</template>

<script>
import cardTypes from '../PageTypeIcon/cardTypes';
import { ref, computed, inject } from '@vue/composition-api';
import { pagesModule } from '@/store/database/pagesModule';
import { addNote, removeNotePages } from '../use/useDocActions';
import useArchiveModal from '@/views/Context/components/ArchiveModal/useArchiveModal';

export default {
  components: {
    'note-page': () => import('@/views/Context/components/ContentSection/NotePage'),
    EmbeddedCardContent: () => import('@/components/ContextDoc/EmbeddedCardContent'),
    'item-card': () => import('./ItemCard')
  },
  props: ['note', 'cards', 'nested', 'draggingOut', 'hoveringPage', 'container', 'inSection'],
  setup(props) {
    const ideaBoard = inject('ideaBoard');
    const { state, setState, setDragStart, updateCardPositions, handleDragEnd } = ideaBoard;
    const colIndex = inject('colIndex');

    const page = pagesModule.doc(props.note.pageId).data;
    const pageNotes = computed({
      get() {
        const page = pagesModule.doc(props.note.pageId).data;
        return Object.values(page.pageNotes)
          .filter(p => !p.toDelete && p.id != undefined)
          .sort((a, b) => (a.order > b.order ? 1 : -1));

        // return notes.map((n, i) => ({ x: 0, y: i * 100 + 30, ...n }));
      },
      set(v) {
        console.log('set computed', v);
      }
    });

    const childrenLength = computed(() => {
      return pageNotes.value.length;
    });

    function stripHTML(textToStrip) {
      var div = document.createElement('div');
      div.innerHTML = textToStrip;
      return div.textContent || div.innerText || '';
    }

    const selected = computed(
      () => !!state.selectedCardRefs.value.find(s => s.note.id == props.note.id)
    );
    const isContainer = ref(!!childrenLength.value && !props.nested);

    const hoveringContainer = computed(() => {
      return (
        isContainer.value &&
        state.hoverContainer.value &&
        state.hoverContainer.value.id == props.note.id &&
        !state.hoverPage.value &&
        state.draggingCard.value &&
        state.draggingCard.value.id != props.note.id
      );
    });

    const icon = computed(() => {
      return cardTypes.find(c => c.value == page.type) || {};
    });

    const title = computed(() => {
      return stripHTML(page.title);
    });

    const showNotePage = ref(false);

    const { openArchiveModal } = useArchiveModal();

    return {
      icon,
      colIndex,
      setState,
      setDragStart,
      updateCardPositions,
      handleDragEnd,
      title,
      showNotePage,
      page,
      pageNotes,
      isContainer,
      childrenLength,
      hoveringContainer,
      selected,
      removeNotePages,
      openArchiveModal,
      addNote,
      ...state
    };
  },
  data() {
    return {
      dragging: false,
      editing: false,
      width: this.nested ? '100%' : this.note.startWidth ? this.note.startWidth : '350',
      maxWidth: this.nested ? '100%' : this.note.startWidth ? this.note.startWidth : '350',
      startPos: {
        view: {
          // relative to viewport
          x: 0,
          y: 0
        },
        canvas: {
          //  relative to canvas position
          x: 0,
          y: 0
        }
      }
    };
  },
  mounted() {
    this.width = '350';
    this.maxWidth = '350';
    if (!this.note.x || !this.note.y) {
      // this.updateCardPositions({ x: 10, y: 10 });
    }
  },
  beforeDestroy() {
    this.setState('hoverPage', false);
    this.setState('hoverContainer', false);
    document.removeEventListener('mousemove', this.handleMove);
    document.removeEventListener('mouseup', this.dragStartListenEnd);
  },
  computed: {},
  methods: {
    setupEditing() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.cardContent.traverseIn({});
      });
    },
    async createNote(order) {
      if (!this.isContainer) this.isContainer = true;

      console.log('create child');
      await this.addNote({
        pageId: this.page.id,
        pageType: 0,
        order
      });
      this.setState('showAddNewCard', false);
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.children[this.$refs.children.length - 1].setupEditing();
      });
    },
    testForDragStart(e) {
      console.log('test dor drag start');
      this.pz.pause();
      if (this.editing) {
        console.log('editing!');
        // document.addEventListener('mouseup', () => this.dragStartListenEnd(true));
        return false;
      }
      const canvas = { x: this.note.x, y: this.note.y };
      if (this.nested) {
        const el = this.$el.getBoundingClientRect();
        console.log(el, this.container);
        canvas.x = this.container.x + el.x;
        canvas.y = this.container.y + el.y;
      }

      this.startPos = {
        view: {
          x: e.x,
          y: e.y
        },
        canvas
      };
      document.addEventListener('mousemove', this.handleMove);
      document.addEventListener('mouseup', this.dragStartListenEnd);
    },
    createChildCard(text = 'New Bullet') {
      var ID = function() {
        return (
          'a' +
          Math.random()
            .toString(36)
            .substr(2, 9)
        );
      };
      this.note.children.push({
        id: ID(),
        title: text,
        icon: 0,
        fetched: true,
        children: [],
        isContainer: false,
        tagId: null,
        x: 0,
        y: 0
      });
    },
    handleMove(event) {
      if (!this.dragging) {
        if (
          Math.abs(this.startPos.view.x - event.x) > 3 ||
          Math.abs(this.startPos.view.y - event.y) > 3
        ) {
          console.log('start drag!');
          this.dragStart(event);
        }
      } else {
        this.updatePos(event);
      }
    },
    dragStartListenEnd() {
      console.log('end drag start listen');
      // if (!this.editing) {
      //   this.pz.resume();
      // }
      this.pz.resume();
      document.removeEventListener('mousemove', this.handleMove);
      document.removeEventListener('mouseup', this.dragStartListenEnd);
    },
    dragStart(e) {
      console.log('actual drag start');
      //  get relative position to canvas
      const el = this.$el.getBoundingClientRect();
      const coord = { x: el.x, y: el.y };
      console.log(e.shiftKey, this.inSection);
      if (this.nested) {
        //  we are dragging out of a context
        const parent = this.container;
        console.log(parent, this.$el);
        coord.x = parent.x + this.$el.offsetLeft;
        coord.y = parent.y + this.$el.offsetTop;

        this.startPos = {
          view: {
            x: e.x,
            y: e.y
          },
          canvas: {
            x: coord.x,
            y: coord.y
          }
        };
      } else {
        this.startPos = {
          view: {
            x: e.x,
            y: e.y
          },
          canvas: {
            x: this.note.x,
            y: this.note.y
          }
        };
      }
      console.log(this.$el, this.container, this.note.id);
      this.setDragStart({
        note: this.note,
        pageId: this.container.pageId,
        coord,
        nested: this.nested || (e.shiftKey && this.inSection)
      });
      // this.$emit('dragStart', this.$el.getBoundingClientRect());
      this.dragging = true;
      document.addEventListener('mouseup', this.dragEnd);
    },
    dragEnd() {
      console.log('end drag');
      this.dragging = false;
      // this.$emit('dragEnd');
      this.handleDragEnd();
      document.removeEventListener('mousemove', this.handleMove);
      document.removeEventListener('mouseup', this.dragEnd);
    },
    updatePos(e) {
      const { scale } = this.pz.getTransform();
      const { view, canvas } = this.startPos;
      const changeLeft = e.x - view.x;
      const left = canvas.x + changeLeft / scale;
      const changeRight = e.y - view.y;
      const right = canvas.y + changeRight / scale;
      this.updateCardPositions({ x: left, y: right });
      //console.log(e);
    }
  }
};
</script>

<style>
.no-events {
  pointer-events: none;
}

.nested-title {
  font-size: 14px;
}
</style>
